module.exports = __webpack_public_path__ + "static/img/shisan.5d469c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shisan.png
// module id = pfmm
// module chunks = 1